import React, { useState } from "react";
import { Icons } from "../components/Icons";
import ProductCard from "../components/UI/ProductCard";
import { CATEGORIES, CATALOG } from "../data/catalog";
import ImageWithFallback from '../components/UI/ImageWithFallback';

const Products = ({ go }) => {
  const [activeCat, setActiveCat] = useState("smartphones");
  const [query, setQuery] = useState("");

  const items =
    CATALOG[activeCat]?.items.filter(
      (p) =>
        p.name.toLowerCase().includes(query.toLowerCase()) ||
        p.desc.toLowerCase().includes(query.toLowerCase()),
    ) || [];

  return (
    <>
      <div className="page-hero">
        <div className="wrap page-hero-inner">
          <div className="breadcrumb">
            <span>Home</span>
            <Icons.ChevronRight size={12} />
            <em>Products</em>
          </div>
          <span className="badge badge-blue">Wholesale Catalog</span>
          <h1>Electronics Product Catalog</h1>
          <p>
            6 categories · 75+ premium products · All available for bulk
            wholesale orders with tiered pricing.
          </p>
        </div>
      </div>
      <section className="section">
        <div className="wrap">
          <div className="products-layout">
            <div className="products-sidebar">
              <div className="ps-head">
                <h4>Product Categories</h4>
              </div>
              <div className="ps-list">
                {CATEGORIES.map((cat) => (
                  <div
                    key={cat.id}
                    className={`ps-item${activeCat === cat.id ? " active" : ""}`}
                    onClick={() => {
                      setActiveCat(cat.id);
                      setQuery("");
                    }}
                  >
                    <div className="ps-item-img">
                      <ImageWithFallback
                        src={cat.img}
                        alt={cat.name}
                        loading="lazy"
                        onError={(e) => {
                          e.target.style.opacity = "0";
                        }}
                      />
                    </div>
                    <span className="ps-item-name">{cat.name}</span>
                    <span className="ps-item-count">{cat.count}</span>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <div className="products-main-header">
                <div>
                  <h3 style={{ color: "var(--gray-900)" }}>
                    {CATALOG[activeCat]?.name || "Products"}
                  </h3>
                  <p style={{ fontSize: ".8rem", marginTop: 2 }}>
                    {items.length} products
                  </p>
                </div>
                <div className="search-box">
                  <Icons.Search size={15} />
                  <input
                    placeholder="Search products…"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                  />
                </div>
              </div>
              <div
                className="prod-grid prod-grid-3"
              >
                {items.map((p) => (
                  <ProductCard
                    key={p.id}
                    product={p}
                    catName={CATALOG[activeCat]?.name || ""}
                    go={go}
                  />
                ))}
              </div>
              {items.length === 0 && (
                <div
                  style={{
                    textAlign: "center",
                    padding: "64px 0",
                    color: "var(--gray-400)",
                  }}
                >
                  <Icons.Search size={40} color="#d1d5db" />
                  <p style={{ marginTop: 12 }}>No products match "{query}"</p>
                </div>
              )}
              <div style={{ marginTop: 56 }}>
                <div className="cta-banner">
                  <div className="cta-banner-glow" />
                  <div style={{ position: "relative" }}>
                    <h3 style={{ color: "#fff", marginBottom: 8 }}>
                      Can't find what you're looking for?
                    </h3>
                    <p style={{ color: "rgba(255,255,255,.65)" }}>
                      Our global sourcing team can locate any product within 48
                      hours.
                    </p>
                    <button
                      className="btn btn-orange"
                      style={{ marginTop: 20 }}
                      onClick={() => go("contact")}
                    >
                      Submit a Sourcing Request{" "}
                      <Icons.ArrowRight size={15} color="#fff" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Products;
